module.exports = __webpack_public_path__ + "static/img/qgl.7dbb7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qgl.png
// module id = J7pX
// module chunks = 0